import {h, Component} from 'preact';
import { CreatePasswordInput } from '@webapp/preact-shared';
import CloseButtonWithCircle from '../tags/close-button-with-circle';
import ResetPasswordRequest from '../../services/resetPasswordRequest';

export default class CreatePassword extends Component {
    constructor() {
        super();
        this.state = {
            pageHeader: 'Create workplace_ password',
            subTitle: '',
            isGoodPassword: false,
            passwordError: '',
            createPasswordLoading: false,
            onVerifyAgain: false
        }
    }

    setPasswordValidation = isGoodPassword => {
        this.setState({ isGoodPassword });
    };

    setVerifyAgainSection = () => {
        this.setState({
            pageHeader: 'That took a little too long...',
            subTitle: 'For security reasons please verify your account again.',
            onVerifyAgain: true
        });
    };

    createPassword = () => {
        const password = this.props.getPassword();
        if (this.state.createPasswordLoading) {
            console.log('Loading...');
        } else {
            this.setState({ createPasswordLoading: true, passwordError: '' });
            ResetPasswordRequest.resetPassword(password)
                .then(() => {
                    this.setState({ createPasswordLoading: false, passwordError: '' });
                    this.props.setStep('passwordChanged');
                }, error => {
                    this.setState({ createPasswordLoading: false });
                    if (error.response.status === 409) {
                        this.setState({ passwordError: 'The password is prohibited, please try a new one.' });
                    } else if (error.response.status === 403) {
                        this.setVerifyAgainSection();
                    } else {
                        this.setState({ passwordError: 'Server error, please try later.' });
                    }
                });
        }
    };

    verifyAgain = () => {
        this.props.setStep('phoneCodeVerification');
    };

    goToLoginPage = () => {
        this.props.goToPage('/');
    };

    render({setPassword}, {pageHeader, subTitle, isGoodPassword, passwordError, createPasswordLoading, onVerifyAgain}) {
        return(
            <div className='form'>
                <h2>{pageHeader} <CloseButtonWithCircle action={this.goToLoginPage}/></h2>
                {onVerifyAgain ? (
                    <div>
                        <p className='sub-title'>{subTitle}</p>
                        <div className='bottom-buttons clearfix'>
                            <a className='button button-prime pull-right' onClick={this.verifyAgain}>
                                Verify again
                            </a>
                        </div>
                    </div>
                ) : (
                    <div className='create-new-password clearfix'>
                        <CreatePasswordInput setPassword={setPassword}
                                             passwordError={passwordError}
                                             action={this.createPassword}
                                             setPasswordValidation={this.setPasswordValidation}
                                             minLength={9}
                        />
                        <div className='bottom-buttons clearfix'>
                            <a className={`button-prime button pull-right ${isGoodPassword ? '' : 'disabled'} ${createPasswordLoading ? 'loading' : ''}`}
                               onClick={this.createPassword}>
                                Create password
                            </a>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/scripts/views/reset-password/create-password.js